export default __webpack_public_path__ + "static/media/FADO.ba6e4667.png";